<script>
import Swal from "sweetalert2";
import { cloneDeep } from "lodash";
import { required } from "vuelidate/lib/validators";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import MaskedInput from "vue-text-mask";
import draggable from "vuedraggable";

export default {
    components: {
        MaskedInput,
        draggable
    },
    data() {
        return {
            submitted: false,
            tableData: [],
            modalTitle: "",
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filter: null,
            filterOn: [],
            sortBy: "sort",
            sortDesc: false,
            fields: [
                {
                    key: "sort",
                    sortable: true,
                    label: "#",
                    thStyle: { width: "60px" },
                },
                {
                    key: "activityName",
                    sortable: false,
                    label: "Activity Name",
                },
                {
                    key: "description",
                    sortable: false,
                    label: "Description",
                },
                {
                    key: "intervalDate",
                    sortable: false,
                    label: "Interval",
                    thStyle: { width: "180px" },
                },
                {
                    key: "uniqueRep",
                    sortable: false,
                    label: "Unique Reports",
                    thStyle: { width: "220px" },
                },
                {
                    key: "showOnDashboard",
                    sortable: false,
                    label: "Dashboard",
                    thClass: 'text-center',
                    thStyle: { width: "90px" },
                },
                {
                    key: "actions",
                    label: "Actions",
                    thStyle: { width: "90px" },
                    
                },
            ],
            form: {
                id: 0,
                activityName: "",
                description: "",
                intervalDate: "",
                bidActivityReports: []
            },
            indexSelected: -1,
            tableBusy: false,
            currencyMask: createNumberMask({
                prefix: "",
                allowDecimal: false,
            }),
            dragging: false,
            copyData: [],
            uniqueReports: [],
            typedUR: null,
        };
    },
    validations: {
        form: {
            activityName: { required },
        },
    },
    computed: {
        filtered(){
            let data = this.tableData;
            if (this.filter && this.filter.trim() != "") {
                data = data.filter((item) => {
                    return item.activityName
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            return data;
        },
        rows() {
            return this.tableData.length;
        },
        wasMoved(){
            return JSON.stringify(this.tableData) !=  JSON.stringify(this.copyData);
        }
    },
    created(){
        this.$store
            .dispatch("bidactivity/GetUniqueBidActivityReports")
            .then((res) => {
                if (res.data.error) {
                    return this.showToast(res.data.errorMessage, "error");
                }
                this.uniqueReports = res.data;
            })
            .catch((err) => {
                this.showToast("Something went wrong!", "error");
            });
    },
    methods: {
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        addBidActivity() {
            this.onReset();
            this.modalTitle = "Create New Bid Activity";
            this.$bvModal.show("bid-activity-modal");
        },
        onCreate() {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            } else {
                let data = cloneDeep(this.form);
                data.intervalDate = this.getExactAmt(this.form.intervalDate);
                let x = []
                if (this.form.id > 0) {
                    this.$store
                        .dispatch(
                            "bidactivity/UpdateBidActivity",
                            data
                        )
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(
                                    res.data.errorMessage,
                                    "error"
                                );
                            }
                            data.bidActivityReports.map(y => {
                                x.push(y.reportType);
                            })
                            data.bidActString = x.join(', ');
                            this.tableData.splice(this.indexSelected, 1, data);
                            this.$bvModal.hide("bid-activity-modal");
                            this.showToast("Successfully updated!", "success");
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!", "error");
                        });
                } else {
                    this.$store
                        .dispatch(
                            "bidactivity/CreateBidActivity",
                            data
                        )
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            res.data.bidActivityReports.map(y => {
                                x.push(y.reportType);
                            })
                            res.data.bidActString = x.join(', ');
                            this.tableData.push(res.data);
                            this.$bvModal.hide("bid-activity-modal");
                            this.showToast("Successfully created!", "success");
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
                this.submitted = false;
            }
        },
        updateDashboard(row){
            let data = cloneDeep(row);
            data.showOnDashboard = !row.showOnDashboard;
            this.$store
                .dispatch("bidactivity/UpdateBidActivity", data)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    row.showOnDashboard = data.showOnDashboard;
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        onReset() {
            this.form = {
                id: 0,
                activityName: "",
                description: "",
                intervalDate: "",
                bidActivityReports: [{
                    id: 0,
                    reportType: '',
                    reportName: '',
                    search: false
                }]
            };
        },
        addMoreLabel(){
            this.form.bidActivityReports.push({
                id: 0,
                reportType: '',
                reportName: '',
                search: false
            })
        },
        updateItem(props) {
            this.form = cloneDeep(props);
            this.form.intervalDate = props.intervalDate.toString();
            this.indexSelected = this.tableData.indexOf(props);
            this.modalTitle = "Update Bid Activity";
            this.$bvModal.show("bid-activity-modal");
        },
        hideModal() {
            this.$bvModal.hide("bid-activity-modal");
        },
        deleteItem(props) {
            var index = this.tableData.indexOf(props);
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch(
                            "bidactivity/DeleteBidActivity",
                            props.item.id
                        )
                        .then((res) => {
                            if (res.status == 204) {
                                this.tableData.splice(index, 1);
                                this.showToast(
                                    "Successfully deleted!",
                                    "success"
                                );
                            }
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            });
        },
        getBidActivity() {
            this.tableBusy = true;
            this.$store
                .dispatch("bidactivity/GetAllBidActivity")
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, 'error');
                    }
                    res.data.map(item => {
                        let x = [];
                        item.bidActivityReports.map(y => {
                            x.push(y.reportType);
                        })
                        item.bidActString = x.join(', ');
                    })
                    this.tableData = res.data;
                    this.copyData = cloneDeep(this.tableData);
                    this.tableBusy = false;
                })
                .catch(() => {
                    this.tableBusy = false;
                    this.showToast("Something went wrong!", "error");
                });
        },
        saveSorting(){
            let data = [];
            this.tableData.map((item, index) => {
                item.sort = index + 1;
                data.push({
                    id: item.id,
                    sort: item.sort
                })
            })
            this.$store
                .dispatch("bidactivity/UpdateBidSort", data)
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, 'error');
                    }
                    this.copyData = cloneDeep(this.tableData);
                    this.showToast("Updated successfully!", "success");
                })
                .catch(() => {
                    this.showToast("Something went wrong!", "error");
                });
            
        },
        filteredFileLabel(title){
            let data = this.uniqueReports;
            return data.filter(x => x.reportType.toUpperCase().includes(title.toUpperCase()));
        },
        selectFileLabel(item, index){
            this.form.bidActivityReports[index].reportType = item.reportType;
            this.form.bidActivityReports[index].search = false;
        },
        whenTypeUR(row){
            this.typedUR = row;
        },
        closeLabel(){
            this.typedUR.search = false;
        }
    },
};
</script>

<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="card border">
                    <div class="card-body">
                        <div
                            class="
                                d-flex
                                justify-content-between
                                align-items-center
                            "
                        >
                            <h4 class="card-title m-0">
                                Bid Activity List
                            </h4>
                            <button
                                type="button"
                                @click="addBidActivity()"
                                class="
                                    btn btn-md btn-info
                                    d-flex
                                    align-items-center
                                "
                            >
                                <i class="bx bx-plus fs-6"></i>Create New
                            </button>
                            <b-modal
                                id="bid-activity-modal"
                                :title="modalTitle"
                                size="md"
                                title-class="font-18"
                                hide-footer
                                no-close-on-backdrop
                            >
                                <form
                                    @submit.prevent="onCreate"
                                    class="needs-validation"
                                    ref="fcForm"
                                >
                                    <div class="mb-3">
                                        <label for="activityName">Activity Name</label>
                                        <input
                                            id="activityName"
                                            type="text"
                                            v-model="form.activityName"
                                            placeholder="Enter Activity Name..."
                                            class="form-control"
                                            :class="{
                                                'is-invalid':
                                                    submitted &&
                                                    $v.form.activityName.$error,
                                            }"
                                            autocomplete="off"
                                        />
                                        <div
                                            v-if="
                                                submitted && $v.form.activityName.$error
                                            "
                                            class="invalid-feedback"
                                        >
                                            <span v-if="!$v.form.activityName.required"
                                                >This value is required.</span
                                            >
                                        </div>
                                    </div>
                                    <div class="mb-3">
                                        <label for="code">Description </label>
                                        <input
                                            id="code"
                                            type="text"
                                            v-model="form.description"
                                            placeholder="Enter Description..."
                                            class="form-control"
                                            autocomplete="off"
                                        />
                                    </div>
                                    <div class="mb-3">
                                        <label for="unitId" class="mb-0">Interval Day/s</label>
                                        <masked-input
                                            autocomplete="off"
                                            type="text"
                                            v-model="form.intervalDate"
                                            class="form-control"
                                            :mask="currencyMask"
                                        ></masked-input>
                                    </div>
                                    <div class="mb-3">
                                        <label>Unique Reports</label>
                                        <div v-for="(x, index) in form.bidActivityReports" :key="index" class="mb-1 d-flex align-items-center">
                                            <div class="w-100">
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    v-model="x.reportType"
                                                    :ref="`uniqueReport${index}`"
                                                    @input="whenTypeUR(x)"
                                                    v-click-outside="closeLabel"
                                                />
                                                <div
                                                    class="
                                                        selection-wrapper
                                                        position-absolute
                                                    "
                                                    :style="{'width': $refs[`uniqueReport${index}`][0].clientWidth + 'px'}"
                                                    v-if="x.reportType && x.search"
                                                >
                                                    <ul
                                                        class="
                                                            multiselect__content
                                                            text-left
                                                        "
                                                    >
                                                        <li
                                                            class="multiselect__element"
                                                            v-for="label in filteredFileLabel(x.reportType)"
                                                            :key="label.id"
                                                            @click="selectFileLabel(label, index)"
                                                        >
                                                            <span class="multiselect__option">{{ label.reportType }}</span
                                                            >
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <a href="javascript:void(0);" @click="form.bidActivityReports.splice(index, 1)" class="line-height-1">
                                                <i class="bx bx-trash text-danger font-size-20 ms-1"></i>
                                            </a>
                                        </div>
                                    </div>
                                    <button type="button" class="btn btn-block border border-2" @click="addMoreLabel"><i class="bx bx-plus"></i>Add More Reports</button>
                                    <div class="modal-footer">
                                        <button
                                            type="submit"
                                            class="btn btn-primary"
                                        >
                                            Save changes
                                        </button>
                                        <button
                                            type="button"
                                            class="btn btn-link"
                                            @click="$bvModal.hide('bid-activity-modal')"
                                        >
                                            Close
                                        </button>
                                    </div>
                                </form>
                            </b-modal>
                        </div>
                        <div class="row mt-4">
                            <div class="col-sm-12 col-md-6">
                                <!-- <div
                                    id="tickets-table_length"
                                    class="dataTables_length"
                                >
                                    <label
                                        class="d-inline-flex align-items-center"
                                    >
                                        Show&nbsp;
                                        <b-form-select
                                            class="form-select form-select-sm"
                                            v-model="perPage"
                                            size="sm"
                                            :options="pageOptions"
                                        ></b-form-select
                                        >&nbsp;entries
                                    </label>
                                </div> -->
                            </div>
                            <!-- Search -->
                            <div class="col-sm-12 col-md-6">
                                <div
                                    id="tickets-table_filter"
                                    class="dataTables_filter text-md-end"
                                >
                                    <label
                                        class="d-inline-flex align-items-center"
                                    >
                                        Search:
                                        <b-form-input
                                            autocomplete="off"
                                            v-model="filter"
                                            type="search"
                                            placeholder="Search..."
                                            class="
                                                form-control form-control-sm
                                                ms-2
                                            "
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                            <!-- End search -->
                        </div>
                        <div class="table-responsive mb-0">
                            <table class="table table-striped table-bordered">
                                <thead>
                                    <tr>
                                        <th v-for="x in fields" :key="x.key" :style="x.thStyle" :class="x.thClass">{{x.label}}</th>
                                    </tr>
                                </thead>
                                <draggable 
                                    v-model="tableData" 
                                    tag="tbody"
                                    handle=".handle" 
                                    @start="dragging = true"
                                    @end="dragging = false"
                                >
                                    <tr v-for="x in filtered" :key="x.id">
                                        <td class="handle" :class="{'cursor-grabbing': dragging, 'cursor-grab': !dragging}">{{x.sort}}</td>
                                        <td>{{x.activityName}}</td>
                                        <td>{{x.description}}</td>
                                        <td>{{x.intervalDate}}</td>
                                        <td>{{x.bidActString}}</td>
                                        <td class="text-center">
                                            <a 
                                                href="javascript:void(0);" 
                                                class="bx fs-4 font-weight-bold" 
                                                :class="[x.showOnDashboard ? 'text-success bx-check' : 'text-danger bx-x']"
                                                @click="updateDashboard(x)"
                                            ></a>
                                        </td>
                                        <td class="text-right">
                                            <b-dropdown
                                                id="dropdown-dropleft"
                                                right
                                                variant="link"
                                                toggle-class="text-decoration-none"
                                                menu-class="dropdown-menu-end"
                                                no-caret
                                            >
                                                <template #button-content>
                                                    <i
                                                        class="fas fa-ellipsis-v"
                                                    ></i>
                                                </template>
                                                <b-dropdown-item
                                                    @click="updateItem(x)"
                                                    variant="secondary"
                                                    ><i
                                                        class="
                                                            mdi mdi-update
                                                            font-size-18
                                                            me-1
                                                        "
                                                    ></i
                                                    >Edit</b-dropdown-item
                                                >
                                                <b-dropdown-item
                                                    @click="deleteItem(x)"
                                                    variant="danger"
                                                    ><i
                                                        class="
                                                            mdi mdi-trash-can
                                                            font-size-18
                                                            me-1
                                                        "
                                                    ></i
                                                    >Delete</b-dropdown-item
                                                >
                                            </b-dropdown>
                                        </td>
                                    </tr>
                                </draggable>
                                <tbody>
                                    <template v-if="!tableBusy && !tableData.length">
                                        <tr>
                                            <td colspan="100%" class="text-center">No data found</td>
                                        </tr>
                                    </template>
                                    <template v-if="tableBusy">
                                        <tr>
                                            <td colspan="100%">
                                                <div
                                                    class="
                                                        d-flex
                                                        justify-content-center
                                                        align-items-center
                                                    "
                                                >
                                                    <div class="preloader-component me-2">
                                                        <div class="status">
                                                            <div class="spinner-chase w-20px h-20px">
                                                                <div class="chase-dot"></div>
                                                                <div class="chase-dot"></div>
                                                                <div class="chase-dot"></div>
                                                                <div class="chase-dot"></div>
                                                                <div class="chase-dot"></div>
                                                                <div class="chase-dot"></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <strong>Loading...</strong>
                                                </div>
                                            </td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <button class="btn btn-success btn-sm" v-if="wasMoved" @click="saveSorting"><i class="bx bx-save"></i> Save sorting</button>
                            </div>
                            <!-- <div class="col">
                                <div
                                    class="
                                        dataTables_paginate
                                        paging_simple_numbers
                                        float-end
                                    "
                                >
                                    <ul
                                        class="
                                            pagination pagination-rounded
                                            mb-0
                                        "
                                    >
                                        <b-pagination
                                            v-model="currentPage"
                                            :total-rows="rows"
                                            :per-page="perPage"
                                        ></b-pagination>
                                    </ul>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
